import { Button, Typography } from '@mui/material';
import { Component } from 'react';

export default class RoundButton extends Component {
    render() {
        return (
            <Button disabled={this.props.disabled} type={this.props.submit ? 'submit' : 'button'} onClick={e => this.props.onClick ? this.props.onClick(e) : {}} size="small" color={"btnStyle"} variant="contained" disableElevation style={{ borderRadius: 25 }}><Typography variant="caption">{this.props.children}</Typography></Button>
        );
    }
}